import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import SearchResultsContent from '@PROJECT_ROOT/assets/responsive-frontend/pages/SearchResults/SearchResultsContent';
import GlobalPageComponents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/globalPageComponents';
import initAfterContentComponent from '@PROJECT_ROOT/assets/responsive-frontend/js/services/AfterContentComponent';
import initMobileFixedButtonsWhereSearchAlreadyExistOnPage from '@PROJECT_ROOT/assets/responsive-frontend/js/services/initMobileFixedButtonsWhereSearchAlreadyExistOnPage';
import { PageContextProvider } from '@PROJECT_ROOT/assets/responsive-frontend/js/contexts/PageContext';

const searchResults = document.getElementById(pageConfig.searchResultsPage.id);
if (searchResults) {
    const ssrData = window.SSR_DATA || null;
    const ssrParameters = window.SSR_PARAMETERS || null;
    const ssrSecondaryData = window.SSR_SECONDARY_DATA || null;
    const ssrTertiaryData = window.SSR_TERTIARY_DATA || null;
    const ssrSearchForm = window.SSR_SEARCH_FORM || null;

    hydrateRoot(
        searchResults,
        <>
            <GlobalPageComponents />
            <PageContextProvider userJWT={ssrParameters?.userJWT}>
                <SearchResultsContent
                    publicResourcesSSR={ssrData}
                    facilitiesPublicResourcesSSR={ssrSecondaryData}
                    filtersPublicResourcesSSR={ssrTertiaryData}
                    ssrParameters={ssrParameters}
                    ssrSearchForm={ssrSearchForm}
                />
            </PageContextProvider>
        </>,
    );
}
initAfterContentComponent();
initMobileFixedButtonsWhereSearchAlreadyExistOnPage();
